const getters = {
	getData: (state) => (type) => {
		return state.extData[type]
	},
    dataErrors: state => state.userErrors,
    dataStatus: state => state.status,
}

export default getters
